import { Injectable, EventEmitter } from '@angular/core';
import { JwtAuthenticationService } from '../../authentication/services/jwt-authentication.service';
import { AuthenticationUser } from '../../authentication';
/**
 * This service handles the user permissions.
 *
 * @export
 * @class PermissionService
 */
@Injectable()
export class PermissionService {
  /**
   * This event fires, when the permissions changed.
   *
   * @type {EventEmitter<boolean>}
   * @memberof PermissionService
   */
  public permissionsChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private readonly userAuthenticationService: JwtAuthenticationService) {
    this.userAuthenticationService.currentUser.subscribe(user => {
      this.permissionsChanged.emit(true);
      this.user = new AuthenticationUser(user);
    });
  }

  private user: AuthenticationUser;

  /**
   * Returns true if the user has the permission.
   *
   * @param {string} key
   * @returns {boolean}
   * @memberof PermissionService
   */
  public canActivate(key: string): boolean {
    return key && this.userAuthenticationService.currentUserSubject.value
      ? this.user.permissions.find(i => i.name === key) !== undefined
      : false;
  }
}
